import useFeature from "hooks/useFeature";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
const useIsInvestigationAIReportEnabled = () => {
  const isAIReportFeatureEnabled = useFeature("investigation_report_by_ai");
  const {
    data: { isEnabled }
  } = useAIConfiguration();
  return isEnabled && isAIReportFeatureEnabled;
};
export default useIsInvestigationAIReportEnabled;
